import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

export default function VendorModal({ vendor, onSaved, onClose }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (vendor) {
      setName(vendor.name || '');
      setPhone(vendor.phone || '');
      setEmail(vendor.email || '');
      setSpecialty(vendor.specialty || '');
      setNotes(vendor.notes || '');
    }
  }, [vendor]);

  const handleSave = async () => {
    if (!name.trim()) { setError('Name is required.'); return; }
    setLoading(true);
    setError('');

    const payload = {
      name: name.trim(),
      phone: phone.trim() || null,
      email: email.trim() || null,
      specialty: specialty.trim() || null,
      notes: notes.trim() || null,
    };

    if (vendor) {
      const { data, error } = await supabase
        .from('vendors')
        .update(payload)
        .eq('id', vendor.id)
        .select()
        .single();
      if (error) { setError(error.message); setLoading(false); return; }
      onSaved(data, false);
    } else {
      const { data, error } = await supabase
        .from('vendors')
        .insert(payload)
        .select()
        .single();
      if (error) { setError(error.message); setLoading(false); return; }
      onSaved(data, true);
    }

    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{vendor ? 'Edit Vendor' : 'Add Vendor'}</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          {error && <div className="error-msg">{error}</div>}

          <div className="form-group">
            <label>Name *</label>
            <input
              autoFocus
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="e.g. Mike's Plumbing"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Phone</label>
              <input
                value={phone}
                onChange={e => setPhone(e.target.value)}
                placeholder="e.g. (843) 555-1234"
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="e.g. mike@example.com"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Specialty</label>
            <input
              value={specialty}
              onChange={e => setSpecialty(e.target.value)}
              placeholder="e.g. Plumbing, HVAC, Cleaning"
            />
          </div>

          <div className="form-group">
            <label>Notes</label>
            <textarea
              value={notes}
              onChange={e => setNotes(e.target.value)}
              placeholder="Any additional details..."
            />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={loading}>
            {loading ? 'Saving...' : vendor ? 'Save Changes' : 'Add Vendor'}
          </button>
        </div>
      </div>
    </div>
  );
}
